import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Avatar } from 'shared-components/image/avatar';
import { injectIntl } from 'react-intl';

const UserList = ({ users, keyPrefix = '', intl }) => {
  return (
    <ul className="UserList">
      {
        _.map(users, (user = {}) => {
          if (_.isString(user)) {
            return (
              <li key={`${keyPrefix}${user}`} data-testing-id="user">
                <span style={{ wordBreak: 'break-all' }}>{user}</span>
              </li>
            );
          }

          const ssoId = _.get(user, 'sso-id');
          const avatarUrl = _.get(user, 'avatar-url');
          const firstName = _.get(user, 'first-name');
          const lastName = _.get(user, 'last-name');
          const lastInitial = 'string' === typeof lastName ? (lastName.charAt(0) + '.') : '';
          const displayName = !firstName ? intl.formatMessage({ id: 'invite.attendee_list.anonymous', defaultMessage: 'Anonymous' }) :
          `${firstName} ${lastInitial}`;

          return (
            <li key={`${keyPrefix}${ssoId}`} data-testing-id="user">
              <Avatar src={avatarUrl} />
              <span>{displayName}</span>
            </li>
          );
        })
      }
    </ul>
  );
};

UserList.propTypes = {
  users: PropTypes.object,
  keyPrefix: PropTypes.string
};

export default injectIntl(UserList);
